import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '@/contexts/OrganizationContext';
import { influencerRepository } from '../repositories/influencer.repository';
import { mapLookupRowToInfluencerDetail } from '../services/influencer.mappers';
import { influencerKeys } from '../services/influencer.keys';
import type { InfluencerDetail } from '../types/influencer.types';

export function useInfluencer(id: string | undefined) {
  const { currentOrganization } = useOrganization();
  const orgId = currentOrganization?.id;

  return useQuery({
    queryKey: influencerKeys.detail(orgId, id),
    queryFn: async (): Promise<InfluencerDetail> => {
      if (!id) throw new Error('Influencer ID is required');
      if (!orgId) throw new Error('Organization context is required');
      const row = await influencerRepository.getById(id, orgId);
      return mapLookupRowToInfluencerDetail(row);
    },
    enabled: !!id && !!orgId,
    staleTime: 60_000,
  });
}
